// API client da Biblioteca de Vídeos e Imagens (Pexels + Pixabay).
// O backend só devolve metadados + URLs do CDN do provedor: o download acontece
// DIRETO do CDN no navegador (zero tráfego de mídia na VPS).
import axios from 'axios';

const API = `${import.meta.env.VITE_BACKEND_URL}/api/media`;

const auth = () => ({
  headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
});

// Busca paginada. type: 'image'|'video'; orientation: 'all'|'horizontal'|'vertical'|'square';
// sources: array de provedores (ex.: ['pexels','pixabay']).
export async function searchMedia({ type = 'image', q, orientation = 'all', page = 1, sources = [] }) {
  const { data } = await axios.get(`${API}/search`, {
    ...auth(),
    params: {
      q,
      type,
      orientation,
      page,
      sources: (sources || []).join(','),
    },
  });
  return {
    items: data.items || [],
    page: data.page || page,
    hasMore: !!data.has_more,
    partial: !!data.partial,
    notConfigured: !!data.not_configured,
    statuses: data.statuses || {},
  };
}

// Download DIRETO do CDN: tenta blob (força "salvar como" com nome); se o CDN
// bloquear CORS, abre o link em nova aba (usuário salva). NUNCA passa pela VPS.
export async function downloadMedia(url, filename) {
  if (!url) return;
  try {
    const res = await fetch(url);
    if (!res.ok) throw new Error('cdn');
    const blob = await res.blob();
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = filename || 'darkplanner-media';
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(a.href), 5000);
  } catch {
    window.open(url, '_blank', 'noopener,noreferrer');
  }
}
